import { render, staticRenderFns } from "./invrcpt.vue?vue&type=template&id=2607d336&"
import script from "./invrcpt.vue?vue&type=script&lang=js&"
export * from "./invrcpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports